export const ALL_PHOTO_VISIBILITY_VALUES = ['customer', 'internal', 'closing_details'] as const;

export type PhotoVisibility = typeof ALL_PHOTO_VISIBILITY_VALUES[number];

export const DEFAULT_PHOTO_VISIBILITY: PhotoVisibility = 'customer';

export const PHOTO_VISIBILITY_LABELS: Record<PhotoVisibility, string> = {
  customer: 'Customer',
  internal: 'Internal',
  closing_details: 'Closing Details',
};

export function isValidPhotoVisibility(value: unknown): value is PhotoVisibility {
  if (typeof value !== 'string') return false;
  return ALL_PHOTO_VISIBILITY_VALUES.includes(value as PhotoVisibility);
}

export function normalizePhotoVisibility(value: unknown): PhotoVisibility {
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (isValidPhotoVisibility(normalized)) return normalized;
  }
  return DEFAULT_PHOTO_VISIBILITY;
}

export function isInternalVisibilityPhoto(photo: Record<string, unknown>): boolean {
  return photo.visibility === 'internal';
}

export function filterInternalPhotos<T extends Record<string, unknown>>(photos: T[]): T[] {
  return photos.filter((photo) => !isInternalVisibilityPhoto(photo));
}
